var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 374.999991,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(52.459194, 0, 0, 52.499997, 14.111846, 96.491221)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49997 0.0000184121 L 6.105294 0.0000184121 ",
    stroke: "rgb(100%, 100%, 100%)",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(52.459194, 0, 0, 52.499997, 14.111846, 187.499988)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49997 0.000000234524 L 6.105294 0.000000234524 ",
    stroke: "rgb(100%, 100%, 100%)",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(52.459194, 0, 0, 52.499997, 14.111846, 278.903478)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.49997 -0.0000215988 L 6.105294 -0.0000215988 ",
    stroke: "rgb(100%, 100%, 100%)",
    strokeWidth: 1,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalLines);
export default __webpack_public_path__ + "static/media/vertical-lines.ab2ceab1cb1969fdd0088771dc09b44a.svg";
export { ForwardRef as ReactComponent };